import React from 'react';
import { Link, useNavigate } from "react-router-dom";

const Dashboard = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h1>Dashboard Content</h1>
                    <div className="separator mb-5"></div>
                </div>
                {/* <div className="col-lg-12 col-xl-3">
                    <div className="icon-cards-row">
                        <div className="glide dashboard-numbers">
                            <div className="glide__track" data-glide-el="track">
                                <ul className="glide__slides">
                                    <li className="glide__slide">
                                        <a href="#" className="card">
                                            <div className="card-body text-center">
                                                <i className="iconsminds-clock"></i>
                                                <p className="card-text mb-0">Pending Orders</p>
                                                <p className="lead text-center">16</p>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    )
}

export default Dashboard;